import Transform from '@ember-data/serializer/transform';
import {
  normalizeReferences,
  type RawReference,
} from 'lumen/utils/net-revenue/serializer-helpers';
import type { NetRevenueReference } from 'lumen/utils/net-revenue/types';

export default class NetRevenueReferencesTransform extends Transform {
  deserialize(
    serialized: RawReference[] | null | undefined,
  ): NetRevenueReference[] {
    return normalizeReferences(serialized);
  }

  serialize(deserialized: NetRevenueReference[]): NetRevenueReference[] {
    return deserialized;
  }
}
